/**
 * about.jsx was created for the website milestone
 * it displays the final demo video, about info, how to,
 * and creators section
 */
import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card'
import 'bootstrap/dist/css/bootstrap.min.css';
import './aboutStyle.css';

function About() {

    return (
        <div id="about">
                        <div id="header-div">
                            <h2 id="about-div-header">Welcome to LINK2RSVP</h2>
                            <h4 style={{textAlign: "center"}}>Where planning is stress free</h4>
                            <iframe id="video" width="850" height="400" src="https://www.youtube.com/embed/kUQlPPPFYdE" 
                            title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; 
                            encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>
            <div id="about-div">
                <h4 id="about" style={{textAlign: "left"}}>About</h4>
                
                <p style={{textAlign: "left", fontSize: "15pt"}}>
                    Link2Rsvp is a web application that is meant to ease the stress of planning an event.
                    Whether it's a party, club meeting, or a family trip, Link2Rsvp is here to help. You can
                    add events and their details, add contacts that you would like to keep handy, and then invite
                    those guests to your events. You will receive an email once someone new has RSVPed and we will also keep
                    track for you on the website. If something comes up and you need to change your event details, don't sweat it.
                    Just update your event and we will notify your invited guests. Sign up now and get the party started.
                </p>
                
                <h4 id="whyUse" style={{textAlign: "left", marginTop: "50px"}}>Why use Link2rsvp</h4>
                <p style={{textAlign: "left", fontSize: "15pt"}}>
                Why use Link2rsvp? Link2rsvp solves the problem of planning events. Instead of having to send out one massive 
                email, to many of your guests, and then trying to keep track of who has RSVPed yourself. Let Link2rsvp do this for 
                you. Sending a rsvp link to your guests is as easy as clicking one button. Every guests you invite will receive your 
                event's details. If you have to change the event plans, Link2rsvp will tell you invited guest of the change.  
                If your event requires a covid-19 vaccine, Link2rsvp can also provide vaccine legitamacy for Moderna and Johnson & Johnson 
                covid-19 vaccines, by checking the vaccine lot numbers of your guests. If you would like your event to be open to anyone,
                you can download your event QR-code and hand it out to who ever you like.
                </p>
                <h4 id="howTo" style={{textAlign: "left", marginTop: "50px"}}>How to use Link2rsvp</h4>
                <p style={{textAlign: "left", fontSize: "15pt"}}>
                To get started with Link2rsvp, you need to <a href="/login">log in</a>. If you don't already have an account, 
                you can <a href="/signup">create</a> one. After you have logged in under your account, you can start adding your contacts 
                and events that you have planned. Your contacts can be added, edited, and deleted under the contacts column. 
                Your events can also be added, edited, and deleted under the events column. Once you have contacts and an 
                event added, you are ready to start inviting your guests. Simply click your event image, navigate to the 
                invite tab, and check all the contacts that you would like to invite to the event. If any plans change with 
                the event, just naviagate to the edit tab, change the current event details to the new ones, write a message 
                that will be emailed with the event changes, and click update. Your invited guests will be emailed the new event details.
                </p>
                {
                    /**
                     * sign up
                     * add contacts
                     * add event
                     * invite
                     * and wait for guest to rsvp
                     */
                }
                <h4 id="getstarted" style={{textAlign: "left", marginTop: "50px"}}>Getting Started</h4>
                <div>
                <Row>
                    <Col>
                        <Card style={{ width: '30rem'}}>
                            <Card.Img height="250px" variant="top" src="/images/signup.png"/>
                            <Card.Body>
                                <Card.Title>Step 1</Card.Title>
                                <Card.Text>
                                    <p>You're going to need an account. You can create one <a href="/signup">here</a>.</p>
                                    <br></br>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ width: '30rem'}}>
                            <Card.Img height="250px" variant="top" src="/images/contacts_add.png"/>
                            <Card.Body>
                                <Card.Title>Step 2</Card.Title>
                                <Card.Text>
                                    <p>After you are in your account. Add your contacts that
                                    you would like to keep handy.</p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row style={{marginTop: "50px"}}>
                    <Col>
                        <Card style={{ width: '30rem'}}>
                            <Card.Img height="250px" variant="top" src="/images/creating_event.png"/>
                            <Card.Body>
                                <Card.Title>Step 3</Card.Title>
                                <Card.Text>
                                    <p>Next, Create your first event.</p>
                                    <br></br>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ width: '30rem'}}>
                            <Card.Img height="250px" variant="top" src="/images/inviting.png"/>
                            <Card.Body>
                                <Card.Title>Step 4</Card.Title>
                                <Card.Text>
                                    <p>Go into your event and invite your guests from your contacts list.</p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                </div>
                <h4 id="gallery" style={{textAlign: "left", marginTop: "50px"}}>Gallery</h4>
                <Carousel variant="dark" id="link2rsvp-pics">
                    <Carousel.Item>
                        <img
                        className="gallerypics"
                        width="850" height="400"
                        src="/images/homescreen_3.png"
                        alt="fist slide"
                        />
                        <h5 style={{textAlign: "center"}}>Home Screen</h5>
                        <Carousel.Caption>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="gallerypics"
                        width="850" height="400"
                        src="/images/eventDets.png"
                        alt="second slide"
                        />
                        <h5 style={{textAlign: "center"}}>Event Details</h5>
                        <Carousel.Caption>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="gallerypics"
                        width="850" height="400"
                        src="/images/eventEdit.png"
                        alt="third slide"
                        />
                        <h5 style={{textAlign: "center"}}>Event Edit</h5>
                        <Carousel.Caption>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="gallerypics"
                        width="850" height="400"
                        src="/images/event_rsvp.png"
                        alt="fourth slide"
                        />
                        <h5 style={{textAlign: "center"}}>Rsvp Page</h5>
                        <Carousel.Caption>
                        </Carousel.Caption>
                    </Carousel.Item>
                </Carousel>
                <h4 style={{textAlign: "left", marginTop: "50px"}} id="creators">Creators</h4>
                <p style={{textAlign: "left"}}>Bricen Bennett: <a href="https://www.linkedin.com/in/bricenbennett/">Linkedin</a> , <a href="https://github.com/bricenb">Github</a></p>
                <p style={{textAlign: "left"}}>Xander Majek: <a href="https://github.com/amajek">Github</a></p>
                <p style={{textAlign: "left"}}>Rawlings Oguna: <a href="https://github.com/roguna343">Gighub</a></p>
                <p style={{textAlign: "left"}}>Miles Colbert: <a href="https://www.linkedin.com/in/miles-colbert">Linkedin</a></p>

                <h4 style={{textAlign: "left"}}>Github</h4>
                <p style={{textAlign: "left"}}><a href="https://github.com/SCCapstone/Cola-web">Github Repo</a></p>
                </div>
        </div>
    );

}
export default About;